export default __webpack_public_path__ + "static/media/gjengen.9f2f07e3.webp";